module.exports = __webpack_public_path__ + "static/a-father-first-ac98ca1398f753684bcc98d8160fb703.jpg";